import React, { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { PageLoader } from 'src/components/PageLoader';
import { useAuth } from 'src/utils/auth';
import { AppProvider } from './context';

const PrivateApp = lazy(() =>
    import('src/components/PrivateApp').then((module) => ({ default: module.PrivateApp }))
);

export default function App() {
    const { user, login, isLoggingIn, refetchUser } = useAuth();

    useEffect(() => {
        if (!isLoggingIn && !user) {
            login(null);
        }
    }, [isLoggingIn, login, refetchUser, user]);

    return (
        <BrowserRouter>
            <Suspense fallback={<PageLoader withMenu />}>
                <AppProvider>
                    {isLoggingIn || !user ? <PageLoader withMenu /> : <PrivateApp />}
                </AppProvider>
            </Suspense>
        </BrowserRouter>
    );
}
